import audience from './audience';
import customer from './customer';

export default {
  namespaced: true,
  state: {},
  modules: {
    audience,
    customer
  }
}
